<template>
  <div class="container-fluid p-0">
    <div class="row">
      <div class="col-12 col-sm-12 col-md-6 col-lg-6 col-xl-8">
        <div
            class="back-image"
            :style="'background-image: url(' + configData.company_banner + ')'"
        ></div>
      </div>
      <div class="col-12 col-sm-12 col-md-6 col-lg-6 col-xl-4 pl-md-0">
        <div class="login-form d-flex align-items-center">
          <form
              class="sign-in-sign-up-form w-100"
              ref="form"
              data-url="/admin/users/login"
              action="store"
          >
            <div class="text-center mb-4">
              <img
                  :src="configData.company_logo"
                  alt=""
                  class="img-fluid logo"
              />
            </div>
            <div class="form-row">
              <div class="form-group col-12 px-0">
                <h6 class="text-center mb-0">{{ $t("hi_there") }}</h6>
                <label class="text-center d-block">{{
                    $t("log_in_to_your_dashboard")
                  }}</label>
              </div>
            </div>
            <div class="form-row">
              <div class="form-group col-12 px-0">
                <label for="login_email">{{ $t("email") }}</label>
                <app-input
                    type="email"
                    v-model="login.email"
                    :placeholder="$t('enter_your_email')"
                    :required="true"
                />
              </div>
            </div>
            <div class="form-row">
              <div class="form-group col-12 px-0">
                <label for="login_password">{{ $t("password") }}</label>
                <app-input
                    type="password"
                    v-model="login.password"
                    :placeholder="$t('enter_your_password')"
                    :required="true"
                />
              </div>
            </div>
            <div class="form-row" v-if="recaptchaEnable == 1">
              <div class="form-group col-12 px-0">
                <re-captcha :site-key="siteKey"></re-captcha>
              </div>
            </div>
            <div class="form-row">
              <div class="form-group col-12 px-0 mb-2">
                <app-load-more
                    :preloader="preloader"
                    :label="$t('login')"
                    type="submit"
                    class-name="btn btn-primary btn-block text-center"
                    @submit="submit"
                />
              </div>
            </div>
            <div class="form-row">
              <div class="form-group col-12 px-0">
                <a
                    href="/user/registration/steptwo"
                    class="
                    btn btn btn-primary btn-block
                    text-center
                    bluish-text
                    d-flex
                    align-items-center
                    justify-content-center
                    d-block
                  "
                >
                  {{ $t("registration") }}
                </a>
              </div>
            </div>
            <div
                class="
                form-row form-row
                flex-column flex-md-row
                justify-content-center
                justify-content-md-between
                justify-content-lg-between
              "
            >
              <a
                  href="/forget-password"
                  class="
                  bluish-text
                  d-flex
                  align-items-center
                  justify-content-center justify-content-lg-end
                "
              >
                <app-icon name="lock" class="pr-2"/>
                {{ $t("forgot_password") }}
              </a>
            </div>
            <div class="form-row">
              <div class="col-12">
                <p class="text-center mt-5">
                  {{ $t("copyright_text") + configData.company_name }}
                </p>
              </div>
            </div>
          </form>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import ThemeMixin from "../../../../core/mixins/global/ThemeMixin";
import {AuthMixin} from "./Mixins/AuthMixin";
import {initializeApp} from "firebase/app";
import {getMessaging, getToken} from "firebase/messaging";
import axios from "axios";

export default {
  name: "Login",
  mixins: [AuthMixin, ThemeMixin],
  components: {},
  props: {
    siteKey: String,
    recaptchaEnable: {},
  },
  data() {
    return {
      // login: {email: "aqeel@letscodify.com", password: "oracle", token:null},
      login: {},
      // firebaseConfig: {
      //   apiKey: "AIzaSyC4jI_qTMEqnG2bRz_jHo37e2X1RCb07Xk",
      //   authDomain: "onchip-crm.firebaseapp.com",
      //   projectId: "onchip-crm",
      //   storageBucket: "onchip-crm.appspot.com",
      //   messagingSenderId: "384340319875",
      //   appId: "1:384340319875:web:583f479c5cc1fe038345b6",
      //   measurementId: "G-0XL9EQ8E5Y"
      // },
      // firebaseApp: {},
      // messaging: {},
      // user: {},
      // allowNotification: Notification.permission,
      // notificationToken: window.localStorage.getItem("firebaseToken")

    };
  },
  // watch: {
  //   allowNotification: function (val) {
  //     this.requestPermission(this)
  //   },
  // },
  mounted() {
    localStorage.setItem("theme", "light");
    // this.messaging = getMessaging();
  },
  methods: {
    submit() {
      // if (this.allowNotification === 'granted') {
      //   this.login.token = this.notificationToken
        this.save(this.login);
      // } else {
      //   this.allowNotification = window.confirm("Click Allow to receive notifications.")
      // }

    },
    afterSuccess(res) {
      this.user = res.data.loggedInUser;
      // this.sendTokenToServer(this.notificationToken)
      
      window.location = res.data.url;
    },
    // requestPermission(app) {
    //   Notification.requestPermission().then(function (status) {
    //     if (status === 'denied') {
    //       window.confirm("Click OK to receive notifications.")
    //     } else if (status === 'granted') {
    //       app.allowNotification = 'granted';
    //       app.firebaseTokenRequest();
    //     }
    //   });
    // },
    firebaseTokenRequest() {
      this.firebaseApp = initializeApp(this.firebaseConfig);
      const messaging = this.messaging;
      getToken(messaging, {vapidKey: 'BBrhAO5U2BY8M9vTG0-0Md0og4-9lAz9WY_CYjO-7LZ6qlDHY8npJxijhe2JFkjg62EPCbTpnW7l-_4FNEl9-Js'}).then((currentToken) => {
        if (currentToken) {
          this.notificationToken = currentToken;
          this.setTokenSentToServer(currentToken)
        } else {
          
        }
      }).catch((err) => {
        
      })
    },
    isTokenSentToServer(currentToken) {
      window.localStorage.getItem("firebaseToken") === currentToken
    },
    setTokenSentToServer(currentToken) {
      window.localStorage.setItem(
          "firebaseToken",
          currentToken ? currentToken : ""
      );
    },
    sendTokenToServer(currentToken) {
      axios.post("/admin/users/rest/device/token", {token: currentToken})
          .then((data) => {
            if (data.data.status) {
              this.setTokenSentToServer(currentToken);
            }
          });
    }
  }
}
</script>
